import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dCart$dPromotionData from "../Restaumatic.Cart.PromotionData/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dPromotions$dTypes from "../Restaumatic.Promotions.Types/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dPromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
const show = /* #__PURE__ */ (() => Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.showPromotionalItem(Restaumatic$dCart$dProductKey.showProductKey).show)();
const eqPromotionalItem1 = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.eqPromotionalItem(Restaumatic$dCart$dProductKey.eqProductKey);
const elem = /* #__PURE__ */ (() => {
  const any1 = Data$dFoldable.foldableArray.foldMap((() => {
    const semigroupDisj1 = {append: v => v1 => v || v1};
    return {mempty: false, Semigroup0: () => semigroupDisj1};
  })());
  return x => any1(eqPromotionalItem1.eq(x));
})();
const eqTranslated = /* #__PURE__ */ Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString);
const PromotionalItem = x => x;
const showPromotionalItem = {
  show: v => Data$dString$dCommon.joinWith("\n")([
    "PromotionalItem",
    " { engineItem = " + show(v.engineItem),
    " , promotion = " + Restaumatic$dPromotions$dTypes.showPromotion.show(v.promotion),
    " }"
  ])
};
const promotionalItemPrice = v => {
  if (v.engineItem.selection.tag === "UserEnabled" || v.engineItem.selection.tag === "AutoEnabled") {
    if (v.engineItem.value.tag === "Nothing") { return 0; }
    if (v.engineItem.value.tag === "Just") { return v.engineItem.value._1; }
    $runtime.fail();
  }
  return 0;
};
const promotionalItemMarketingConsent = v => v.promotion.requiresMarketing;
const promotionalItemId = v => v.engineItem.promotionalItemId;
const newtypePromotionalItem = {Coercible0: () => {}};
const promotionalItemDetails = x => x.details;
const promotionalItemEngineItem = x => x.engineItem;
const promotionalItemAssignment = x => x.engineItem.assignment;
const promotionalItemInput = x => x.engineItem.input;
const promotionalItemIsActive = x => x.engineItem.active;
const promotionalItemPromotionId = x => x.engineItem.promotion.promotionId;
const promotionalItemSelectable = x => true;
const promotionalItemSelected = x => x.engineItem.selection.tag === "UserEnabled" || x.engineItem.selection.tag === "AutoEnabled";
const promotionalItemsPartitionCombineable = promotionalItems => {
  const v = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.partitionCombineable(Data$dFunctor.arrayMap(promotionalItemEngineItem)(promotionalItems));
  const $0 = v._1;
  const $1 = v._2;
  return Data$dTuple.$Tuple(
    Data$dArray.filterImpl(item => elem(item.engineItem)($0), promotionalItems),
    Data$dArray.filterImpl(item => elem(item.engineItem)($1), promotionalItems)
  );
};
const promotionalItemPromotion = x => x.promotion;
const promotionalItemAvailability = x => x.promotion.availability;
const promotionalItemCouponPromotion = x => {
  if (x.promotion.promotionType.tag === "Standard") { return false; }
  if (x.promotion.promotionType.tag === "InformationOnly") { return false; }
  return x.promotion.promotionType.tag === "RequiresCoupon";
};
const genericPromotionalItem = {to: x => x, from: x => x};
const eqPromotionalItem = {
  eq: x => y => eqTranslated.eq(x.details.description)(y.details.description) && x.details.id === y.details.id && Restaumatic$dCart$dPromotionData.eqPromotionInputOptions.eq(x.details.inputOptions)(y.details.inputOptions) && eqTranslated.eq(x.details.name)(y.details.name) && eqPromotionalItem1.eq(x.engineItem)(y.engineItem) && Restaumatic$dPromotions$dTypes.eqPromotion.eq(x.promotion)(y.promotion)
};
export {
  PromotionalItem,
  elem,
  eqPromotionalItem,
  eqPromotionalItem1,
  eqTranslated,
  genericPromotionalItem,
  newtypePromotionalItem,
  promotionalItemAssignment,
  promotionalItemAvailability,
  promotionalItemCouponPromotion,
  promotionalItemDetails,
  promotionalItemEngineItem,
  promotionalItemId,
  promotionalItemInput,
  promotionalItemIsActive,
  promotionalItemMarketingConsent,
  promotionalItemPrice,
  promotionalItemPromotion,
  promotionalItemPromotionId,
  promotionalItemSelectable,
  promotionalItemSelected,
  promotionalItemsPartitionCombineable,
  show,
  showPromotionalItem
};
